import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
export default function drillDownEntityDetailsReducer(state = initialState.drillDownEntityDetails, action) {
	switch (action.type) {
		case types.GET_ENTITY_DETAILS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				const entityAttributeName = action.payload.entityAttributeName;
				const entityDetails = action.response;
				return {...entityDetails, entityDisplayName: entityDetails[entityAttributeName]};
			} else if (
				action.error &&
				(action.error.response.status === HttpStatusCodes.NotFound ||
					action.error.response.status === HttpStatusCodes.BadRequest ||
					action.error.response.status === HttpStatusCodes.InternalServerError)
			) {
				return {entityDisplayName: null};
			}
			return state;
		}
		default:
			return state;
	}
}
